export default {
  signature: {
    title: 'Datos de la Firma',
    signatureDate: 'Fecha de firma',
    issuer: 'Emisor del certificado',
    organization: 'Organización',
    serialNumber: 'Número de serie',
    validity: 'Validez',
    to: ' a '
  }
}
